import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53013aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-1" }
const _hoisted_3 = { class: "p-mx-1" }
const _hoisted_4 = { class: "p-mx-1" }
const _hoisted_5 = { class: "p-mx-1" }
const _hoisted_6 = { class: "p-mx-2 p-d-flex p-ai-center" }
const _hoisted_7 = { class: "p-mt-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_9 = { class: "confirmation-content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem","color":"#f44336"}
}, null, -1))
const _hoisted_11 = { style: {"flex":"1"} }
const _hoisted_12 = {
  key: 0,
  class: "p-mb-3"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times-circle p-mr-2" }, null, -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times-circle p-mr-2" }, null, -1))
const _hoisted_16 = { class: "confirmation-content" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Are you sure to delete the product? ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" ?")
const _hoisted_20 = { class: "confirmation-content" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-info-circle p-mr-3",
  style: {"font-size":"2rem","color":"#2196F3"}
}, null, -1))
const _hoisted_22 = { style: {"flex":"1"} }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-mb-3" }, "Choose which fields to update across all stores in this pharmacy:", -1))
const _hoisted_24 = {
  key: 0,
  class: "p-mb-3 p-p-3",
  style: {"background-color":"#e3f2fd","border-radius":"4px","border-left":"4px solid #2196f3"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-info-circle p-mr-2",
  style: {"color":"#1976d2"}
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "First-time Update:", -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" This will create records for all branches in this pharmacy. ")
const _hoisted_28 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "p-field-checkbox p-mb-3"
}
const _hoisted_30 = {
  for: "updateReferenceAllStores",
  class: "p-ml-2"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Reference:", -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 2,
  class: "p-field-checkbox p-mb-3"
}
const _hoisted_35 = {
  for: "updateMinStockAllStores",
  class: "p-ml-2"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Min Stock Qty:", -1))
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 3,
  class: "p-field-checkbox p-mb-3"
}
const _hoisted_40 = {
  for: "updateProductLocationAllStores",
  class: "p-ml-2"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Product Location:", -1))
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "p-text-secondary p-d-block" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle p-mr-1" }, null, -1))
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "confirmation-content" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-info-circle p-mr-3",
  style: {"font-size":"2rem","color":"#2196F3"}
}, null, -1))
const _hoisted_50 = { style: {"flex":"1"} }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-mb-3" }, "Choose which fields to update across all stores in this pharmacy for ALL products in the CSV:", -1))
const _hoisted_52 = {
  key: 0,
  class: "p-field-checkbox p-mb-3"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "csvUpdateReferenceAllStores",
  class: "p-ml-2"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Reference:"),
  /*#__PURE__*/_createTextVNode(" Update all stores within this pharmacy ")
], -1))
const _hoisted_54 = {
  key: 1,
  class: "p-field-checkbox p-mb-3"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "csvUpdateMinStockAllStores",
  class: "p-ml-2"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Min Stock Qty:"),
  /*#__PURE__*/_createTextVNode(" Update all stores within this pharmacy ")
], -1))
const _hoisted_56 = {
  key: 2,
  class: "p-field-checkbox p-mb-3"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "csvUpdateProductLocationAllStores",
  class: "p-ml-2"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Product Location:"),
  /*#__PURE__*/_createTextVNode(" Update all stores within this pharmacy ")
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "p-text-secondary p-d-block" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle p-mr-1" }),
  /*#__PURE__*/_createTextVNode(" Unchecked fields will only update the current store for each product. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_FileUploader = _resolveComponent("FileUploader")!
  const _component_ProductForm = _resolveComponent("ProductForm")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Toolbar, null, {
          start: _withCtx(() => [
            _createVNode(_component_Breadcrumb, {
              home: _ctx.home,
              model: _ctx.items,
              class: "p-menuitem-text"
            }, null, 8, ["home", "model"])
          ]),
          end: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (this.addUploadProduct)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-upload",
                    label: "Upload Products",
                    class: "p-button-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openProductUploader()))
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              (this.addUpdateProduct)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-download",
                    label: "Download Product CSV",
                    class: "p-button-warning",
                    onClick: _ctx.downloadCSV
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              (this.addUpdateProduct)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-upload",
                    label: "Update Product CSV",
                    class: "p-button-primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openFileUploader()))
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              false
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-plus",
                    label: "Add Product",
                    class: "p-button-success",
                    onClick: _ctx.openDialog
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.keyword,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.keyword) = $event)),
                modelModifiers: { trim: true },
                placeholder: "Product Name, Generic Name, Common Name, Reference, Barcode",
                style: {"width":"20rem"},
                class: "p-mr-2",
                onKeydown: _withKeys(_ctx.handleSearch, ["enter"])
              }, null, 8, ["modelValue", "onKeydown"]),
              _createVNode(_component_Button, {
                icon: "pi pi-search",
                class: "p-button-success p-ml-2",
                onClick: _ctx.loadSearchData,
                disabled: !_ctx.keyword || _ctx.keyword.trim() === ''
              }, null, 8, ["onClick", "disabled"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_DataTable, {
            first: _ctx.goToFirstLink,
            "onUpdate:first": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
            firstModifiers: { sync: true },
            value: _ctx.lists,
            dataKey: "id",
            ref: "dt",
            lazy: true,
            paginator: _ctx.checkPagination,
            rows: Number(_ctx.limit),
            totalRecords: _ctx.totalRecords,
            resizableColumns: true,
            columnResizeMode: "expand",
            responsiveLayout: "scroll",
            onPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPage($event))),
            class: "p-datatable-sm p-datatable-striped p-datatable-gridlines",
            rowClass: _ctx.rowClass
          }, {
            empty: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "ID" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.id), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Product Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.product_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Generic Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.generic_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Common Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.common_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Reference(*)" }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_InputText, {
                    style: {"width":"80px"},
                    modelValue: slotProps.data.reference,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.reference) = $event),
                    disabled: _ctx.editingRow !== slotProps.data.id,
                    class: "p-p-1"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Min Stock" }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_InputText, {
                    modelValue: slotProps.data.min_stock,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.min_stock) = $event),
                    disabled: _ctx.editingRow !== slotProps.data.id,
                    style: {"width":"80px"},
                    class: "p-p-1"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Product Location" }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_InputText, {
                    style: {"width":"80px"},
                    modelValue: slotProps.data.product_location,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.product_location) = $event),
                    disabled: _ctx.editingRow !== slotProps.data.id,
                    class: "p-p-1"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                  (_ctx.addUpdateProduct)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: 
                                    _ctx.editingRow === slotProps.data.id
                                        ? 'pi pi-check'
                                        : 'pi pi-pencil'
                                ,
                        class: _normalizeClass([
                                    _ctx.editingRow === slotProps.data.id
                                        ? 'p-button-rounded p-button-primary'
                                        : 'p-button-rounded p-button-success'
                                , "p-mr-2"]),
                        onClick: ($event: any) => (_ctx.toggleEdit(slotProps.data)),
                        disabled: 
                                    !_ctx.canEdit(slotProps.data) &&
                                    !_ctx.enableEditButton
                                
                      }, null, 8, ["icon", "class", "onClick", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Barcode" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.barcode), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Unit Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.getUnitNameById(slotProps.data.unit_id)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Unit Value" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.unit_value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Prescription" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.prescription === 1 ? "Yes" : "No"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Insurance" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.insurance === 1 ? "Yes" : "No"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Expirable" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.expirable === 1 ? "Yes" : "No"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Product Type*" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.getProductTypeById(slotProps.data.type_id)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Brand Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.getBrandNameById(slotProps.data.brand_id)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Brand Sector" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.getBrandSectorById(
                                    slotProps.data.brand_sector_id
                                )), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Category" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.getCategoryById(slotProps.data.category_id)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Side Effects" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.side_effects), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Description" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.description), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                exportable: false,
                header: "Action"
              }, {
                body: _withCtx((slotProps) => [
                  (this.deleteProduct)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "pi pi-trash",
                        class: "p-button-rounded p-button-danger",
                        onClick: ($event: any) => (_ctx.confirmDeleteItem(slotProps.data)),
                        disabled: !slotProps.data.created_by
                      }, null, 8, ["onClick", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["first", "value", "paginator", "rows", "totalRecords", "rowClass"]),
          _createVNode(_component_FileUploader, {
            uploaderDetail: {
                        status: _ctx.prodUploaderStatus,
                        dialogTitle: 'Upload Products:',
                        imageType: '.csv',
                    },
            onUpdateUploaderStatus: _ctx.updateProductUploader
          }, null, 8, ["uploaderDetail", "onUpdateUploaderStatus"]),
          _createVNode(_component_FileUploader, {
            uploaderDetail: {
                        status: _ctx.uploaderStatus,
                        dialogTitle: 'Upload Products Details CSV File:',
                        imageType: '.csv',
                    },
            onUpdateUploaderStatus: _ctx.updateUploaderStatus
          }, null, 8, ["uploaderDetail", "onUpdateUploaderStatus"]),
          _createVNode(_component_ProductForm, {
            productDialog: _ctx.productDialog,
            "onUpdate:productDialog": [
              _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productDialog) = $event)),
              _cache[6] || (_cache[6] = ($event: any) => (_ctx.productDialog = $event))
            ],
            dialogTitle: 'Add New Product',
            onSaveProduct: _ctx.handleProductSave,
            onCloseDialog: _ctx.closeDialog
          }, null, 8, ["productDialog", "onSaveProduct", "onCloseDialog"])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.errorDialog,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.errorDialog) = $event)),
      style: { width: '600px' },
      header: "Validation Errors"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "OK",
          icon: "pi pi-check",
          class: "p-button-success",
          onClick: _ctx.closeErrorDialog
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_ctx.validationErrors.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationErrors, (message, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'validation-' + index,
                      class: "p-mb-2",
                      style: {"font-size":"0.95rem","color":"#d32f2f"}
                    }, [
                      _hoisted_13,
                      _createTextVNode(_toDisplayString(message), 1)
                    ]))
                  }), 128))
                ]))
              : (_ctx.errorMessages().length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMessages(), (message, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'error-' + index,
                        class: "p-mb-2",
                        style: {"font-size":"0.95rem"}
                      }, [
                        _hoisted_15,
                        _createTextVNode(_toDisplayString(message), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.deleteConfirmationDialog,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.deleteConfirmationDialog) = $event)),
      style: { width: '450px' },
      header: "Confirm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-success",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteConfirmationDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          class: "p-button-danger",
          onClick: _ctx.handleClick
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("span", null, [
            _hoisted_18,
            _createElementVNode("b", null, _toDisplayString(_ctx.state.productName), 1),
            _hoisted_19
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.updateConfirmationDialog,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.updateConfirmationDialog) = $event)),
      style: { width: '550px' },
      header: "Update Product"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          icon: "pi pi-times",
          class: "p-button-secondary",
          onClick: _ctx.cancelUpdate
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Update",
          icon: "pi pi-check",
          class: "p-button-primary",
          onClick: _ctx.confirmUpdate
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            (_ctx.isFirstTimeUpdate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_28))
              : _createCommentVNode("", true),
            (_ctx.hasSingleReferenceUpdate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createVNode(_component_Checkbox, {
                    id: "updateReferenceAllStores",
                    modelValue: _ctx.updateReferenceAllStores,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.updateReferenceAllStores) = $event)),
                    binary: true,
                    disabled: _ctx.isFirstTimeUpdate
                  }, null, 8, ["modelValue", "disabled"]),
                  _createElementVNode("label", _hoisted_30, [
                    _hoisted_31,
                    (_ctx.isFirstTimeUpdate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Will be applied to all branches (first-time update)"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_33, "Update all stores within this pharmacy"))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasSingleMinStockUpdate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createVNode(_component_Checkbox, {
                    id: "updateMinStockAllStores",
                    modelValue: _ctx.updateMinStockAllStores,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.updateMinStockAllStores) = $event)),
                    binary: true,
                    disabled: _ctx.isFirstTimeUpdate
                  }, null, 8, ["modelValue", "disabled"]),
                  _createElementVNode("label", _hoisted_35, [
                    _hoisted_36,
                    (_ctx.isFirstTimeUpdate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Will be applied to all branches (first-time update)"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_38, "Update all stores within this pharmacy"))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasSingleProductLocationUpdate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createVNode(_component_Checkbox, {
                    id: "updateProductLocationAllStores",
                    modelValue: _ctx.updateProductLocationAllStores,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.updateProductLocationAllStores) = $event)),
                    binary: true,
                    disabled: _ctx.isFirstTimeUpdate
                  }, null, 8, ["modelValue", "disabled"]),
                  _createElementVNode("label", _hoisted_40, [
                    _hoisted_41,
                    (_ctx.isFirstTimeUpdate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Will be applied to all branches (first-time update)"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_43, "Update all stores within this pharmacy"))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("small", _hoisted_44, [
              _hoisted_45,
              (_ctx.isFirstTimeUpdate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_46, " First-time updates automatically create records for all branches in the pharmacy. "))
                : (_openBlock(), _createElementBlock("span", _hoisted_47, " Unchecked fields will only update the current store. "))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.csvUpdateConfirmationDialog,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.csvUpdateConfirmationDialog) = $event)),
      style: { width: '550px' },
      header: "Update Products from CSV"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          icon: "pi pi-times",
          class: "p-button-secondary",
          onClick: _ctx.cancelCsvUpdate
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Update All",
          icon: "pi pi-check",
          class: "p-button-primary",
          onClick: _ctx.confirmCsvUpdate
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            (_ctx.hasReferenceUpdates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createVNode(_component_Checkbox, {
                    id: "csvUpdateReferenceAllStores",
                    modelValue: _ctx.csvUpdateReferenceAllStores,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.csvUpdateReferenceAllStores) = $event)),
                    binary: true,
                    disabled: true
                  }, null, 8, ["modelValue"]),
                  _hoisted_53
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasMinStockUpdates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createVNode(_component_Checkbox, {
                    id: "csvUpdateMinStockAllStores",
                    modelValue: _ctx.csvUpdateMinStockAllStores,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.csvUpdateMinStockAllStores) = $event)),
                    binary: true
                  }, null, 8, ["modelValue"]),
                  _hoisted_55
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasProductLocationUpdates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createVNode(_component_Checkbox, {
                    id: "csvUpdateProductLocationAllStores",
                    modelValue: _ctx.csvUpdateProductLocationAllStores,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.csvUpdateProductLocationAllStores) = $event)),
                    binary: true
                  }, null, 8, ["modelValue"]),
                  _hoisted_57
                ]))
              : _createCommentVNode("", true),
            _hoisted_58
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}